import { render, staticRenderFns } from "./ppbatchoverimp.vue?vue&type=template&id=284af9d8&scoped=true&"
import script from "./ppbatchoverimp.vue?vue&type=script&lang=js&"
export * from "./ppbatchoverimp.vue?vue&type=script&lang=js&"
import style0 from "./ppbatchoverimp.vue?vue&type=style&index=0&id=284af9d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284af9d8",
  null
  
)

export default component.exports